import React from 'react';

export default function Hero() {
  return (
    <div className="bg-gradient-to-r from-red-600 to-red-800 rounded-lg p-8 mb-8 text-white">
      <h2 className="text-4xl font-bold mb-4">Welcome to MyMapleShop</h2>
      <p className="text-xl mb-6">Discover amazing products at unbeatable prices</p>
      <button className="bg-white text-red-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100">
        Shop Now
      </button>
    </div>
  );
}